import { render, staticRenderFns } from "./delete-dialog.vue?vue&type=template&id=5441f1ea&"
import script from "./delete-dialog.vue?vue&type=script&lang=ts&"
export * from "./delete-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./delete-dialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports